import { PdfFileIcon } from '@omilia/icon';
import { colors } from '@omilia/theme';
import { PDFDownloadLink } from '@react-pdf/renderer';
import styled from 'styled-components';

export const SMetaMessage = styled.div`
  color: ${colors.COLOR_GREY_800};
  font-size: 12px;
  margin-bottom: 24px;
  text-align: center;
`;

export const SDownloadPDFContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const SChatEnded = styled.span`
  color: ${colors.COLOR_GREY_800};
  font-size: 11px;
  margin-bottom: 24px;
`;

export const SDownloadPDF = styled(PDFDownloadLink)`
  align-items: center;
  color: ${colors.COLOR_BLUE_700};
  display: flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-decoration: none;
`;

export const SPdfIcon = styled(PdfFileIcon)`
  margin-right: 8px;
`;
